import { Outlet, useLoaderData } from 'react-router';

import styles from './styles/premium-tipsters.module.css';
import { loader } from './loader';

export { loader };

export default function PremiumTipstersLayout() {
  const {
    currentPath,
    isWalled,
    repub,
    resourcesUrl,
    userHasActiveSubscription,
    userHasCancelledSubscription,
    wallType,
  } = useLoaderData<typeof loader>();

  return (
    <main className={styles.tipsters}>
      <Outlet
        context={{
          currentPath,
          isWalled,
          repub,
          resourcesUrl,
          userHasActiveSubscription,
          userHasCancelledSubscription,
          wallType,
        }}
      />
    </main>
  );
}
